import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Loader from "react-loader-spinner";
import { useParams } from "react-router-dom";
import { getCorporateJobById, convertToDraftJob, paymentApprovalForFinance,GetCreditLimitDetailByCompany } from "../../Redux/Actions/corporateJobs";
import { apiWrapWithErrorWithData } from "../../utils/apiWrapper";
import { downloadDocument, getCspList } from "../../Redux/Actions/jobs";
import LoadingButton from "../../utils/loadingButton";
import { toastMessage } from "../../utils/toast";
import CustomModal from "../../utils/customModal";
import DropDown from '../Ui/DropDown';
import { Form } from "react-bootstrap";

const DisplayContainer = ({ label, value }) => (
  <div
    className="form-group fv-plugins-icon-container"
    style={{
      marginBottom: "10px",
      paddingBottom: "5px",
      borderBottom: "1px solid #f1f5fa",
    }}
  >
    <span className="text-muted">{label} : </span>
    {value}
  </div>
);

function CorporateJobsDetail({ history }) {
  const { id } = useParams();
  const userData = useSelector(({ User }) => User.data);
  const [pageLoading, setPageLoading] = useState(false);
  const [downloadButtonloading, setDownloadButtonLoading] = useState({});
  const [jobCreateButtonloading, setJobCreateButtonLoading] = useState({});
  const [jobDetail, setJobDetail] = useState({});
  const [creditLimitDetail, setCreditLimitDetail] = useState({});
  const [cspListLoading, setCspListLoading] = useState(false);
  const [cspList, setCspList] = useState([]);
  const [isPopupOpened, setIsPopupOpened] = useState(false);
  const [openedPopupIndex, setOpenedPopupIndex] = useState(0);
  const [openedPopupJobId, setOpenedPopupJobId] = useState(0);
  const [approvedStatusOptions, setApprovedStatusOptions] = useState([
    { label: "Approved", value: 'Approved' },
    { label: "Rejected", value: 'Rejected' }
  ]);
  const [countOptions, setCountOptions] = useState([
    { label: "30 Days", value: '30' },
    { label: "60 Days", value: '60' },
    { label: "90 Days", value: '90' }
  ]);

  const [paymentApproval, setPaymentApproval] = useState({
    approvalStatus: "",
    Description: "",
    refNumber: "",
    dueDate: ""
  });

  const [paymentApprovalLoading, setPaymentApprovalLoading] = useState(false);
  const [paymentApprovalError, setPaymentApprovalError] = useState(false);
  const [showFullData, setShowFullData] = useState(false);
  const [formVisible, setFormVisible] = useState(true);
  const [paymentType, setPaymentType] = useState("");
  const [isShowPaymentApprovalForm, setIsShowPaymentApprovalForm] = useState(true);

 


  useEffect(() => {
    if (id) {
      getCorporateJobByIdApi(id);
      getCspListApi();
     
    }
  }, [id]);

  useEffect(() => {
    getCreditLimitDetailByCompany(jobDetail.companyId);
  }, [jobDetail]);

  const getCorporateJobByIdApi = async (id) => {
    setPageLoading(true);
    try {
      const response = await apiWrapWithErrorWithData(getCorporateJobById(id));
      setJobDetail(response?.data);
      setPaymentType(response?.data?.paymentType);
      setIsShowPaymentApprovalForm(response?.data?.isShowPaymentApprovalForm) 
    } catch (error) {
      console.log("getCorporateJobByIdApi:", error);
    }
    setPageLoading(false);
  };
  
  
  const getCreditLimitDetailByCompany = async (companyId) => {
    setPageLoading(true);
    try {
      const response = await apiWrapWithErrorWithData(GetCreditLimitDetailByCompany(companyId));
      setCreditLimitDetail(response?.data);
    } catch (error) {
      console.log("getCreditLimitDetailByCompany:", error);
    }
    setPageLoading(false);
  };


  const getCspListApi = async () => {
    setCspListLoading(true);
    try {
      const response = await apiWrapWithErrorWithData(getCspList());
      let cspArray = [{ label: "Default", value: '' }];
      response?.data.forEach(list => {
        let object = { label: list.name, value: list.id };
        cspArray.push(object);
      });
      setCspList(cspArray);
    } catch (error) {
      console.log("getCspListApi:", error);
    }
    setCspListLoading(false);
  };

  const [cspSelectedValue, setCspSelectedValue] = useState('');
  const handleCspSelectValue = (list) => {
    setCspSelectedValue(list);
  };

  const body = (
    <>
      <DropDown
        isSearchable={true}
        label={"Select Csp List"}
        placeholder={"Default"}
        options={cspList}
        value={cspSelectedValue}
        onChange={value => handleCspSelectValue(value)}
      />
    </>
  );

  const handleDownload = (documentIds, documentName, index) => {
    const userId = 2;
    const payload = documentIds.map(documentId => ({ userId, documentId }));
    handleDownloadDocument(payload, documentName, index);
  };

  const handleCreateJob = async () => {
    setIsPopupOpened(false);
    setJobCreateButtonLoading((preState) => ({ ...preState, [openedPopupIndex]: true }));
    try {
      const response = await convertToDraftJob(openedPopupJobId, cspSelectedValue.value ?? '');
      toastMessage('success', 'Corporate job has been created successfully');
      setCspSelectedValue('');
      getCorporateJobByIdApi(id);
    } catch (error) {
      console.log("handleCreateJob", error);
      toastMessage('error', error?.response?.data?.Message || "Unable to create corporate job");
    }
    setJobCreateButtonLoading((preState) => ({ ...preState, [openedPopupIndex]: false }));
  };

  const handleDownloadDocument = async (payload, documentName, i) => {
    setDownloadButtonLoading((preState) => ({ ...preState, [i]: true }));
    try {
      const response = await downloadDocument(payload);
      let binary_string = window.atob(response.data.content);
      let len = binary_string.length;
      let bytes = new Uint8Array(len);
      for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
      }
      let blob = new Blob([bytes], { type: response.data.contentType });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = documentName;
      link.click();
    } catch (error) {
      console.log("handleDownloadDocument", error);
    }
    setDownloadButtonLoading((preState) => ({ ...preState, [i]: false }));
  };

  const setPopupOpen = (id, index) => {
    setIsPopupOpened(true);
    setOpenedPopupJobId(id);
    setOpenedPopupIndex(index);
  };

  const setPopupClose = () => {
    setIsPopupOpened(false);
  };

  const handlePaymentApprovalSubmit = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
  
    if (!paymentApproval.approvalStatus.value || !paymentApproval.Description) {
      toastMessage('error', 'Fill the Form');
      setPaymentApprovalError(true);
      return;
    }
    if (paymentType=='BankTransfer' && !paymentApproval.refNumber) {
      setPaymentApprovalError(true);
      return;
    }
    if (paymentType=='Credit' && !paymentApproval.dueDate) {
      setPaymentApprovalError(true);
      return;
    }
    setPaymentApprovalError(false);
    setPaymentApprovalLoading(true);
    
    const payload = {
      corporateCompanyJobId: id,
      status: paymentApproval.approvalStatus.value,
      description: paymentApproval.Description,
      referenceNumber: paymentApproval.refNumber,
      dueDate: paymentApproval.dueDate.value
    };
  
    try {
      const response = await apiWrapWithErrorWithData(paymentApprovalForFinance(payload));
      if (response.status === 400) {
        var message=response.data.Message ?response.data.Message:response.data.message;
        toastMessage('error', message);
      } else {
        toastMessage('success', response.message);
        // setShowFullData(true);
        setFormVisible(false);
        getCorporateJobByIdApi(id);
      }
    } catch (error) {
      toastMessage('error', error.message);
    } finally {
      setPaymentApprovalLoading(false);
    }
  };
  

  const generateDisplayFullData = () => {
    const commonData = [
      { label: "Payment Type", value: jobDetail?.paymentType || "-" },
      { label: "Payment status", value: jobDetail?.paymentStatus || "-" },
      { label: "Payment Completed Date", value: jobDetail?.paymentCompletedDate },
      { label: "Payment Approval Status", value: jobDetail?.pmtApprovalStatus || "-" },
      { label: "Payment Approved By", value: jobDetail?.pmtApprovedBy || "-" },
      { label: "Payment Reference", value:jobDetail?.pmtReferenceNumber },
      { label: "Approved Date", value:"" },
      { label: "Descriptions", value: jobDetail?.pmtApprovedNotes }
    ];

    if (isShowPaymentApprovalForm) {
      if (jobDetail?.paymentType === "Credit") {
        return [...commonData, { label: "Payment completed date", value: jobDetail?.paymentCompletedDate || "N/A" }];
      }
    }

    return commonData;
  };


  return (
    <div className="container-fluid">
      <h4 className="py-3">Corporate Jobs Details</h4>
      {pageLoading ? (
        <div className="d-flex align-items-center justify-content-center h-75vh">
          <Loader
            type="ThreeDots"
            color="#2d207d"
            height={40}
            width={40}  
            style={{ textAlign: "center" }}
          />
        </div>
      ) : (
        <div className="row col-lg-12">
          <div className="card card-custom card-stretch gutter-b p-2">
            <div className="d-flex justify-content-around">
              <div className="p-2">
                {[
                  { label: "Job Reference", value: jobDetail?.corporateJobReference },
                  { label: "Job count", value: jobDetail?.jobCount },
                  { label: "Department name", value: jobDetail?.departmentName },
                  { label: "Master process name", value: jobDetail?.masterProcessName },
                  { label: "Process name", value: jobDetail?.processName },
                  { label: "Po Number", value: jobDetail?.poNumber }
                ].map(({ label, value }) => (
                  <DisplayContainer key={label} label={label} value={value} />
                ))}
              </div>

              {/* Credit limit detail*/}
              <div className="p-2">
                {[
                  { label: "Credit Limit", value: creditLimitDetail?.creditLimit },
                  { label: "Limit Used", value: creditLimitDetail?.creditLimitUsed },
                  { label: "Remaining", value: creditLimitDetail?.creditLimitRemaining },
                ].map(({ label, value }) => (
                  <DisplayContainer key={label} label={label} value={value} />
                ))}

                {creditLimitDetail?.isCreditLimitExceeded && 
                <DisplayContainer key={'Note'} label={'Note'} value={'The credit limit exceeded.'} />
                }
              </div>
              {/*  */}
              <div className="p-2" style={{ width: "30%" }}>
                {userData.Role === '' && isShowPaymentApprovalForm ? (
                  <div>
                    {[
                      { label: "Payment Type", value:jobDetail?.paymentType },
                      { label: "Payment Status", value: jobDetail?.paymentStatus },
                      { label: "Payment Reference", value:jobDetail?.pmtReferenceNumber },
                      { label: "Descriptions", value: jobDetail?.pmtApprovedNotes },
                      { label: "Approved By", value: jobDetail?.pmtApprovedBy},
                      { label: "Approved Date", value:"" },
                      { label: "Completed Date", value: jobDetail?.paymentCompletedDate },
                      
                    ].map(({ label, value }) => (
                      <DisplayContainer key={label} label={label} value={value} />
                    ))}
                  </div>
                ) : (

                  <div>
                    <div>
                      {!isShowPaymentApprovalForm &&
                        generateDisplayFullData().map(({ label, value }) => (
                          <DisplayContainer key={label} label={label} value={value} />
                        ))
                      }
                    </div>

                    {isShowPaymentApprovalForm && formVisible && (
                      <form>
                        {[
                          { label: "Payment Type", value: jobDetail?.paymentType },
                          { label: "Payment status", value: jobDetail?.paymentStatus }
                        ].map(({ label, value }) => (
                          <DisplayContainer key={label} label={label} value={value} />
                        ))}

                        <Form.Group className="mb-2">
                          <Form.Label>Ref Number</Form.Label>
                          <Form.Control
                            type="text"
                            onChange={(event) => {
                              setPaymentApproval(prevState => ({ ...prevState, refNumber: event.target.value }));
                            }}
                            value={paymentApproval.refNumber}
                            placeholder="Enter Ref Number"
                          />
                           {paymentApprovalError && !paymentApproval.refNumber && paymentType=='BankTransfer' &&(
                          <span style={{ color: 'red' }}>Reference no is required</span>
                        )}
                        </Form.Group>

                        <Form.Group className="mb-2">
                          <Form.Label>Description</Form.Label>
                          <Form.Control as="textarea"
                            rows={1}
                            placeholder="Enter Description"
                            onChange={(event) => {
                              setPaymentApproval(prevState => ({ ...prevState, Description: event.target.value }));
                            }}
                            value={paymentApproval.Description}
                          />
                          {paymentApprovalError && !paymentApproval.Description && (
                            <span style={{ color: 'red' }}>Description is required</span>
                          )}
                        </Form.Group>
                        {paymentType === "Credit" && (
                          <DropDown
                            isSearchable={true}
                            label={"Due date"}
                            placeholder={"Select Date"}
                            options={countOptions}
                            value={paymentApproval.dueDate}
                            onChange={(value) => {
                              setPaymentApproval(prevState => ({
                                ...prevState,
                                dueDate: value,
                              }));
                            }}
                          />
                        )}
                         {paymentApprovalError && !paymentApproval.dueDate && paymentType=='Credit' &&(
                            <span style={{ color: 'red' }}>Due date is required</span>
                          )}
                        <DropDown
                          isSearchable={true}
                          label={"Approved Status"}
                          placeholder={"Select Status"}
                          options={approvedStatusOptions}
                          value={paymentApproval.approvalStatus}
                          onChange={(value) => {
                            setPaymentApproval(prevState => ({ ...prevState, approvalStatus: value }));
                          }}
                        />
                        {paymentApprovalError && !paymentApproval.approvalStatus.value && (
                          <span style={{ color: 'red' }}>Approved Status is required</span>
                        )}
                      
                       
                       
                        <LoadingButton
                          style={{ margin: "0rem 1rem 0rem 0rem" }}
                          isLoading={paymentApprovalLoading}
                          onChange={handlePaymentApprovalSubmit}
                        >
                          Submit
                        </LoadingButton>
                      </form>
                    )}
                    {showFullData && (
                      <div>
                        {generateDisplayFullData().map(({ label, value }) => (
                          <DisplayContainer key={label} label={label} value={value} />
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

            </div>

            <hr className="hr-dashed" />
            <div>
              <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                <thead>
                  <tr className="text-center">
                    <th>Document Name</th>
                    <th>Job Request Id</th>
                    <th>Action</th> 
                  </tr>
                </thead>
                <tbody>
                  {jobDetail?.corporateCompanyJobDocuments?.map((doc, i) => (
                    <tr key={doc.documentId} className="text-center">
                      <td>
                        <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{doc.documentName}</span>
                      </td>
                      <td>
                        {doc.jobRequestId ? (
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg"><a type="button" onClick={() => history.push(`/jobs/${doc.jobRequestId}`)}>{doc.jobRequestId}</a></span>
                        ) : (
                          <span className="text-dark-75 font-weight-bolder d-block font-size-lg">-</span>
                        )}
                      </td>
                      <td>
                        <LoadingButton
                          style={{ margin: "1rem" }}
                          isLoading={downloadButtonloading[i]}
                          onChange={() => handleDownload(doc.documentIds, doc.documentName, i)}
                        >
                          Download document
                        </LoadingButton>
                        {doc?.showJobCreateBtn && (
                          <LoadingButton
                            style={{ margin: "1rem" }}
                            isLoading={jobCreateButtonloading[i]}
                            onChange={() => setPopupOpen(doc.id, i)}
                          >
                            Create job
                          </LoadingButton>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      <CustomModal
        body={body}
        handleClose={setPopupClose}
        show={isPopupOpened}
        title={"Confirmation"}
        isLoading={cspListLoading}
        handleSubmit={handleCreateJob}
        name={"Yes"}
      />
    </div>
  );
}

export default CorporateJobsDetail;
